import { useDialog } from '@wui/common-library'
import { HistoryMessageItem, MessageCallReceived } from '@wui/im'

import { AppointmentStatistic } from '@/entities/call-chat-event'

export const useAppointmentPopup = () => {
  const { showDialog } = useDialog()

  const showAppointmentPopup = (
    payload: {
      e: MouseEvent | TouchEvent
      message: string
    },
    event: HistoryMessageItem<MessageCallReceived>,
  ) => {
    showDialog(AppointmentStatistic, {
      event,
      message: payload.message,
      isModal: true,
      hasOverlay: true,
    })
  }

  return {
    showAppointmentPopup,
  }
}
